<div class="d-flex col-12 justify-content-center">
  <div
    class="d-flex font24 col-12 justify-content-center align-items-center my-4"
  >
    <div>Call/Visit Logs</div>
  </div>
</div>

<div class="d-flex col-12 justify-content-center align-items-center">
  <div
    class="d-flex col-12 px-2 justify-content-center align-items-center"
    style="overflow: auto; max-height: 100vh"
  >
    <table class="table table-bordered table-striped">
      <thead class="table-dark">
        <tr class="text-center">
          <th>ID</th>
          <th>Customer Name</th>
          <th>Phone Number</th>
          <th>Mode</th>
          <th>Interaction Date</th>
          <th>Current Status</th>
          <th>Next Action Due</th>
          <th>Last Updated At</th>
          <th>Agent Name</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let interaction of allInteraction; let i = index"
          class="text-center"
        >
          <td>{{ interaction.id }}</td>
          <td>{{ interaction.customerName }}</td>
          <td>{{ interaction.phoneNumber }}</td>
          <td>{{ interaction.modeOfCommunication }}</td>
          <td>{{ interaction.interactionDate | date : "yyyy-MM-dd" }}</td>
          <td>{{ interaction.outcomeStatus }}</td>
          <td>{{ interaction.callNotes }}</td>
          <td>{{ interaction.updatedAt | date : "yyyy-MM-dd HH:mm:ss" }}</td>
          <td>{{ interaction.enteredByName }}</td>
          <td class="d-flex justify-content-between gap-2">
            <button
              class="btn btn-sm btn-primary"
              (click)="openCommentModal(interaction)"
            >
              Comments
            </button>
            <button
              class="btn btn-sm btn-secondary"
              (click)="openEditModal(interaction)"
            >
              Update
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Pagination Controls -->
<div class="d-flex justify-content-center mt-3">
  <button
    class="btn me-2 border-none"
    [disabled]="page === 0"
    (click)="prevPage()"
  >
    &lt;
  </button>
  <span class="align-self-center">
    Page {{ page + 1 }} of {{ totalPages }}</span
  >
  <button
    class="btn ms-2 border-none"
    [disabled]="!hasMore"
    (click)="nextPage()"
  >
    &gt;
  </button>
</div>

<!-- Comment Modal -->
<!-- (Same as before — no changes needed) -->

<!-- Edit Modal -->
<!-- (Same as before — no changes needed) -->

<!-- Comment Modal -->
<div
  class="modal fade show"
  id="commentModal"
  tabindex="-1"
  style="display: none"
  aria-modal="true"
  role="dialog"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Comments for {{ selectedInteraction?.customerName }}
        </h5>
        <button
          type="button"
          class="btn-close"
          (click)="closeCommentModal()"
        ></button>
      </div>
      <div class="modal-body">
        <div *ngIf="selectedInteraction?.comments?.length > 0; else noComments">
          <ul class="list-group mb-3">
            <li
              class="list-group-item"
              *ngFor="let cmt of selectedInteraction.comments"
            >
              <div class="d-flex justify-content-between">
                <span>{{ cmt.comment }}</span>
                <span class="font12 text-grey">
                  {{ cmt.createdByName }} on
                  {{ cmt.createdAt | date : "dd-MMM-YY" }}
                </span>
              </div>
            </li>
          </ul>
        </div>
        <ng-template #noComments>
          <p class="text-muted">No comments yet.</p>
        </ng-template>

        <div class="mb-3">
          <label for="newComment" class="form-label">Add Comment</label>
          <textarea
            [(ngModel)]="newCommentText"
            id="newComment"
            class="form-control"
            rows="3"
          ></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success" (click)="submitComment()">
          Submit Comment
        </button>
        <button class="btn btn-secondary" (click)="closeCommentModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Edit Interaction Modal -->
<div
  class="modal fade show"
  id="editModal"
  tabindex="-1"
  style="display: none"
  aria-modal="true"
  role="dialog"
  *ngIf="editInteraction"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Update Interaction for {{ editInteraction?.customerName }}
        </h5>
        <button
          type="button"
          class="btn-close"
          (click)="closeEditModal()"
        ></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label">Next Action</label>
          <select [(ngModel)]="editInteraction.callNotes" class="form-select">
            <option value="">Select Next Action</option>
            <option *ngFor="let action of nextActions" [value]="action">
              {{ action }}
            </option>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label">Outcome Status</label>
          <select
            [(ngModel)]="editInteraction.outcomeStatus"
            class="form-select"
          >
            <option *ngFor="let status of outcomeStatuses" [value]="status">
              {{ status }}
            </option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success" (click)="submitUpdate()">Update</button>
        <button class="btn btn-secondary" (click)="closeEditModal()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
